import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Table, Button, FloatingLabel, Form } from 'react-bootstrap';
import { get_auth_key, getStoredData } from '../../util';

import 'react-toastify/dist/ReactToastify.css';
import Vendor from '../../components/vendor';
import Factory from '../../components/factory';
import { get } from '../../services/apiController';
import PaginationInPage from '../Pagination';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';

const PurchaseOrder = () => {
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const admins = ['admin', 'super-admin', 'inventory-admin'].includes(storedData.role);
  const [data, setData] = useState([]);
  const [state, setState] = useState({
    vendorId: '',
    factoryId: !admins ? storedData?.locationId[0] || '' : '',
    dateFrom: '',
    dateTo: '',
  });
  const [factories, setFactories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const fetchPurchaseOrder = () => {
    get(
      `/inv/purchase-order/?vendorId=${state.vendorId}&factoryId=${state.factoryId}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`
    )
      .then((res) => {
        setData(res?.data?.rows);
        setTotalRecords(res?.data.count);
      })
      .catch((err) => {
        toast.error(err?.response?.data.data.message || err?.message);
      });
  };

  function getFactories() {
    try {
      get(`/branches/?type=factory`).then((response) => {
        setFactories(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useEffect(() => {
    fetchPurchaseOrder();
  }, [currentPage]);

  useEffect(() => {
    getFactories();
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="row">
            <div className="col-2">
              <h4 className="card-title mt-4" style={{ fontSize: '16px' }}>
                Purchase Order | {totalRecords ?? 0}
              </h4>
            </div>
            <div className="card-header-actions col-10 d-flex justify-content-end">
              <div className="mb-3" style={{ width: '200px', marginRight: '20px' }}>
                <Vendor
                  name="vendorId"
                  vendorId={state?.vendorId}
                  handleVendorChange={(vendorId) => {
                    setState({ ...state, vendorId });
                  }}
                />
              </div>
              <div style={{ width: '200px', marginRight: '20px' }}>
                <FloatingLabel label="Factory" className="mb-3">
                  <Factory
                    factoryId={state.factoryId}
                    onChange={(e) => {
                      setState({ ...state, factoryId: e.target.value });
                    }}
                    factories={factories}
                    label="factory"
                    name="factoryId"
                    disabled={!admins}
                  />
                </FloatingLabel>
              </div>
              <div style={{ width: '200px', marginRight: '20px' }}>
                <FloatingLabel className="mb-3" controlId="floatingInput" label="From Date">
                  <Form.Control value={state.dateFrom} onChange={(e) => setState({ ...state, dateFrom: e.target.value })} type="date" />
                </FloatingLabel>
              </div>
              <div style={{ width: '200px', marginRight: '20px' }}>
                <FloatingLabel className="mb-3" controlId="floatingInput" label="To Date">
                  <Form.Control value={state.dateTo} onChange={(e) => setState({ ...state, dateTo: e.target.value })} type="date" />
                </FloatingLabel>
              </div>
              <div style={{ width: '100px' }}>
                <Button onClick={() => fetchPurchaseOrder()} type="submit" className="btn app-btn-default dark-color mb-3">
                  Apply
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr className="text-center">
                    <th rowSpan="2">#</th>
                    <th rowSpan="2">Date</th>
                    <th rowSpan="2">PO Number</th>
                    <th rowSpan="2">Vendor</th>
                    <th rowSpan="2">Factory</th>
                    <th colSpan="2">Order Details</th>
                  </tr>
                  <tr className="text-center">
                    <th style={{ width: '150px', textAlign: 'center' }}>Item</th>
                    <th style={{ width: '150px', textAlign: 'center' }}>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => {
                    const rowSpan = item?.PurchaseOrderDetails.length;
                    return (
                      <>
                        <tr className="text-center" key={item.id}>
                          <td rowSpan={rowSpan}>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                          <td rowSpan={rowSpan}>{item?.poDate}</td>
                          <td rowSpan={rowSpan}>{item?.poNumber}</td>
                          <td rowSpan={rowSpan}>{item?.VendorMaster?.name}</td>
                          <td rowSpan={rowSpan}>{item?.Branch?.name}</td>
                          <td>{item.PurchaseOrderDetails[0]?.Item?.name}</td>
                          <td>
                            {item.PurchaseOrderDetails[0]?.quantity} {item.PurchaseOrderDetails[0]?.unit}
                          </td>
                        </tr>
                        {item?.PurchaseOrderDetails.map((detail, _index) => {
                          if (_index === 0) {
                            return null;
                          }
                          return (
                            <tr className="text-center">
                              <td>{detail?.Item?.name}</td>
                              <td>{`${detail?.quantity} ${detail?.unit}`}</td>
                            </tr>
                          );
                        })}
                      </>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseOrder;
